import { render, staticRenderFns } from "./PluginRatingStat.vue?vue&type=template&id=a40dd7f4&scoped=true"
import script from "./PluginRatingStat.vue?vue&type=script&lang=js"
export * from "./PluginRatingStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40dd7f4",
  null
  
)

export default component.exports